import { ReportLabelInspection } from '@ulysses-inc/harami_api_client'
import { createContext } from 'react'
import { useGetLabelInspectionResults } from '../api/useGetLabelInspectionResults'

type LabelInspectionResultId = string
export const LabelCheckAnswerStoreContext = createContext<{
  labelInspectionResultMap: Map<LabelInspectionResultId, ReportLabelInspection>
}>({
  labelInspectionResultMap: new Map(),
})

export const LabelCheckAnswerStoreProvider = ({
  ids,
  children,
}: {
  ids: string[]
  children: React.ReactNode
}) => {
  const { data } = useGetLabelInspectionResults(ids)

  const labelInspectionResults = data?.reportLabelInspections ?? []

  const labelInspectionResultMap = new Map(
    labelInspectionResults.map(labelInspectionResult => [
      labelInspectionResult.id,
      labelInspectionResult,
    ]),
  )

  return (
    <LabelCheckAnswerStoreContext.Provider
      value={{
        labelInspectionResultMap,
      }}
    >
      {children}
    </LabelCheckAnswerStoreContext.Provider>
  )
}
